export const DASHBOARD_TABS = [
    {
        name: 'Dashboard 360',
        key: 'dashboard-360',
        dashboardType: 'Insurer_360',
        timePeriodFilterRequired: false,
        tableName: 'Claim Level Data',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC'],
    },
    {
        name: 'Network Summary',
        key: 'provider',
        dashboardType: 'Insurer_Provider',
        timePeriodFilterRequired: false,
        tableName: 'Provider Data',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC'],
    },
    {
        name: 'Performance',
        key: 'claims-dashboard',
        dashboardType: 'PayerDashboard_IHX',
        timePeriodFilterRequired: false,
        filterColumnName: 'ClaimSubmittedDate',
        tableName: 'ClaimData',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: [''],
    },
    {
        name: 'Turnaround Time',
        key: 'tat-report',
        dashboardType: 'ABHITATReport',
        timePeriodFilterRequired: false,
        filterColumnName: 'SubmittedDate',
        tableName: 'ABHITATReport',
        columnName: 'PayerId',
        hideFooterTabs: false,
        requiredFor: ['ABHI', 'HDFC', 'RGI'],
    },
    {
        name: 'Submission Pattern',
        key: 'provider-submission-pattern',
        dashboardType: 'ProviderSubmissionPattern',
        timePeriodFilterRequired: false,
        filterColumnName: 'Claim Creation Date',
        filterTableName: 'SubmissionPattern',
        tableName: 'ProviderSubmissionPattern',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: [''],
    },
    {
        name: 'Claims',
        key: 'claim',
        dashboardType: 'Insurer_Claim',
        timePeriodFilterRequired: false,
        tableName: 'Claim Level Data',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC', 'ICICI', 'MDI'],
    },
    {
        name: 'Transaction',
        key: 'transaction',
        dashboardType: 'Insurer_Transaction',
        timePeriodFilterRequired: false,
        tableName: 'Transaction TAT',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC', 'ICICI', 'MDI'],
    },
    {
        name: 'Documents',
        key: 'document',
        dashboardType: 'Insurer_Documents',
        timePeriodFilterRequired: false,
        tableName: 'Claim Level Data',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC'],
    },
    {
        name: 'Logs',
        key: 'logs',
        dashboardType: 'Logs_IHX',
        timePeriodFilterRequired: false,
        tableName: 'PayerMaster',
        columnName: 'Payer ID',
        hideFooterTabs: false,
        requiredFor: ['ABHI', 'RGI'],
    },
    {
        name: 'CTA Dashboard',
        key: 'cta-dashboard',
        dashboardType: 'CTAReport',
        timePeriodFilterRequired: false,
        tableName: 'CTAData',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC'],
    },
    {
        name: 'Adoption',
        key: 'adoption ',
        dashboardType: 'Insurer_Adoption',
        timePeriodFilterRequired: false,
        tableName: 'Claim Level Data',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC'],
    },
    {
        name: 'Hospital Insights',
        key: 'hospital-insights',
        dashboardType: 'Insurer_Insights',
        timePeriodFilterRequired: false,
        tableName: 'Claim Level Data',
        columnName: 'PayerId',
        hideFooterTabs: true,
        requiredFor: ['ABHI', 'RGI', 'HDFC'],
    },
    {
        name: 'Insurer Report',
        key: 'insurer-report',
        dashboardType: 'Insurer_IHX',
        timePeriodFilterRequired: false,
        tableName: 'Claim Level Data',
        columnName: 'PayerId',
        hideFooterTabs: false,
        requiredFor: [''],
    },
    {
        name: 'Adoption',
        key: 'transaction-adoption',
        dashboardType: 'TransactionAdoption',
        timePeriodFilterRequired: false,
        tableName: 'FinalTrans',
        columnName: 'PayerId',
        hideFooterTabs: false,
        requiredFor: ['MATPA'],
    },
    {
        name: 'Star Executive Dashboard',
        key: 'star-executive-dashboard',
        dashboardType: 'StarDashboard',
        timePeriodFilterRequired: false,
        tableName: 'StarClaims',
        columnName: '',
        hideFooterTabs: false,
        requiredFor: ['StarDirect'],
    },
];